import PropTypes from "prop-types"

export const ReportSelectedEmployeesShape = {
  employeeId: PropTypes.number,
  includeDirectReports: PropTypes.bool,
}

export const ExportDetailsShape = {
  id: PropTypes.number,
  name: PropTypes.string,
  selectedQuestions: PropTypes.arrayOf(PropTypes.shape({
    detailType: PropTypes.number,
    clientWorkflowStepId: PropTypes.number,
    questionId: PropTypes.number,
  })),
}

export const RequestedReportShape = {
  reportId: PropTypes.number.isRequired,
  reportType: PropTypes.string.isRequired,
  requestedDate: PropTypes.string.isRequired,
  requestStatus: PropTypes.string.isRequired,
  downloadLink: PropTypes.string,
}

export const ReviewQuestionShape = {
  questionId: PropTypes.number.isRequired,
  clientWorkflowStepId: PropTypes.number.isRequired,
  detailType: PropTypes.number.isRequired,
  textTranslationIdentifier: PropTypes.string.isRequired,
}

export const ReviewPageShape = {
  formPageId: PropTypes.number.isRequired,
  nameTranslationIdentifier: PropTypes.string.isRequired,
  questions: PropTypes.arrayOf(PropTypes.shape(ReviewQuestionShape)).isRequired,
}

export const WorkflowStepShape = {
  clientWorkflowStepId: PropTypes.number.isRequired,
  nameTranslationIdentifier: PropTypes.string.isRequired,
  pages: PropTypes.arrayOf(PropTypes.shape(ReviewPageShape)).isRequired,
}

export const ReviewDataShape = {
  workflowSteps: PropTypes.arrayOf(PropTypes.shape(WorkflowStepShape)).isRequired,
}

export const ReportSelectedOptionsShape = {
  reviewId: PropTypes.number,
  reportTypeId: PropTypes.number,
  appraisalLevelId: PropTypes.number,
  includeLeavers: PropTypes.bool,
  employeeDetailOptions: PropTypes.arrayOf(PropTypes.number),
  selectedLocations: PropTypes.arrayOf(PropTypes.number),
  selectedEmployees: PropTypes.arrayOf(PropTypes.shape(ReportSelectedEmployeesShape)),
  exportDetails: PropTypes.arrayOf(PropTypes.shape(ExportDetailsShape)),
  reviewData: PropTypes.arrayOf(PropTypes.shape(ReviewDataShape)),
}



// WEBPACK FOOTER //
// ./src/state/shapes/CustomReportShapes.js